<template>
    <p>Página de error.</p>
</template>

<script>
export default {
    name: "ErrorPage",
};
</script>